import { render, staticRenderFns } from "./BankNameChukyo.vue?vue&type=template&id=d61670cc&scoped=true&"
import script from "./BankNameChukyo.vue?vue&type=script&lang=ts&"
export * from "./BankNameChukyo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61670cc",
  null
  
)

export default component.exports